import { render, staticRenderFns } from "./zdyrblinxi.vue?vue&type=template&id=70b12853&scoped=true&"
import script from "./zdyrblinxi.vue?vue&type=script&lang=js&"
export * from "./zdyrblinxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b12853",
  null
  
)

export default component.exports